//@flow
import React from 'react';
import { Switch, Route } from 'react-router-dom';
import SignUp from './signup/components/SignUp';
import { SETUP_STATES } from 'h-signup'
import Loadable from 'react-loadable'
import styled from 'styled-components'
import hiverLoaderImgIdentity from './common/images/spinner-identity.gif'


//Related to loader

const LoadingSpinner = styled.div`
	height: 48px;
	width: 48px;
`
const LoadingScreen = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`
const Loader = () => <LoadingScreen>
		<LoadingSpinner src={hiverLoaderImgIdentity} />
	</LoadingScreen>

const LoadableSetupContainer = Loadable({
	loader: () => import('./setup/components/SetupContainer' /* webpackChunkName: "setupFlow" */ ),
	loading: Loader
})


const App = () => <main>
	<Switch>
		<Route 
			exact 
			path="/" component={SignUp} 
		/>
		<Route 
			path={`/${SETUP_STATES[0]}`} 
			component={LoadableSetupContainer}
		/>
	</Switch>
</main>
	

export default App;